import { Component, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { ApprovalService } from "src/app/_services/approval/approval.service";
import { LocalStorageService } from "src/app/_services/localStorage/local-storage.service";
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi, CellClassRules, IDetailCellRendererParams, ExcelExportParams, 
  ProcessRowGroupForExportParams, ExcelCell, ExcelStyle, ICellRendererParams, GridOptions } from 'ag-grid-enterprise';
import { FirstDataRenderedEvent } from 'ag-grid-community';
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { DatePipe, formatDate } from "@angular/common";
import { HrService } from 'src/app/_services/hr-management/hr.service';
const { Parser, transforms: { unwind, flatten } } = require('json2csv');
import { MatSnackBar } from "@angular/material/snack-bar";


const fields = [ { label: 'User Id', value: 'userId' }, { label: 'Name', value: 'name' }, 
{ label: 'Leaves Taken In Current Month', value: 'leavesTakenInCurrentMonth'}, 
{ label: 'Approved Leaves Id', value: 'approvedLeaves.id' }, { label: 'Approved Leaves User Id', value: 'approvedLeaves.userId' }, 
{ label: 'Approved Leaves Leave Type', value: 'approvedLeaves.leavetype' }, { label: 'Approved Leaves Start Date', value: 'approvedLeaves.startDate' }, 
{ label: 'Approved Leaves End Date', value: 'approvedLeaves.endDate' }, { label: 'Approved Leaves Reason', value: 'approvedLeaves.leaveReason' }, 
{ label: 'Approved Leaves Status', value: 'approvedLeaves.status' }, { label: 'Approved Leaves Application Date', value: 'approvedLeaves.applicationDate' }, 
{ label: 'Approved Leaves Applied By UserId', value: 'approvedLeaves.appliedByUserId' }, 
{ label: 'Approved Leaves Applied By UserName', value: 'approvedLeaves.appliedByUserName' }, 
{ label: 'Approved Leaves UserId UserName', value: 'approvedLeaves.userIdUserName' }, 
{ label: 'Approved Leaves Application Title', value: 'approvedLeaves.applicationTitle' }, 
{ label: 'Approved Leaves Duration', value: 'approvedLeaves.duration' }, 
{ label: 'Approved Leaves Delegated To UserId', value: 'approvedLeaves.delegatedToUserId' }, 
{ label: 'Approved Leaves Delegated To UserName', value: 'approvedLeaves.delegatedToUserName' }, 
{ label: 'Approved Leaves Approved Date', value: 'approvedLeaves.approvedDate' }, 
{ label: 'Approved Leaves Half Day', value: 'approvedLeaves.halfDay' },
{ label: 'Remaining Leaves Id', value: 'remainingLeaves.id' }, 
{ label: 'Remaining Leaves UserId', value: 'remainingLeaves.userId' }, 
{ label: 'Remaining Leaves Leave Type', value: 'remainingLeaves.leaveType' }, 
{ label: 'Remaining Leaves Balance', value: 'remainingLeaves.balance' } ];
const transforms = [unwind({ paths: ['approvedLeaves', 'remainingLeaves'], blankOut: true, flatten: true })];

@Component({
  selector: 'app-leave',
  templateUrl: './leave.component.html',
  styleUrls: ['./leave.component.scss']
})
export class LeaveComponent implements OnInit {
  leaveapplicationForm
  rowData: any;
  public columnDefs: ColDef[];
  modeAction: number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any
  tenantId: string;
  userDetails: any;
  form: FormGroup;
  selectedRow: any;
  modalService: any;
  currentUser: any;
  jsonData: any;
  emailPattern = "^[a-z0-9._%+-]+\\.[a-z]{2,4}$";
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  dataSource_leaveapplication: any;
  selectedRowApprovalSend;
  leaveReport: FormGroup;
  leaveApprovals: any;
  
  gridOptions: GridOptions;
  private excelApi: GridApi;
  private excelApi2: GridApi;
  private excelApiColumnApi: ColumnApi;
  reportColumnDefs: ColDef[];
  @ViewChild('excelGrid', { read: ElementRef }) excelGridElementRef: ElementRef;
  
  public detailCellRendererParams: any = {
    detailGridOptions: {
      columnDefs: [
        {
          headerName: 'Approved Leaves',
          children: [
            { 
              headerName: 'Id', 
              field: 'id'
            },
            { 
              headerName: 'User Id',
              field: 'userId' 
            },
            { 
              headerName: 'Leave Type',
              field: 'leavetype'
            },
            { 
              headerName: 'Start Date',
              field: 'startDate' 
            },
            { 
              headerName: 'End Date',
              field: 'endDate' },
            { 
              headerName: 'Leave Reason',
              field: 'leaveReason' },
            { 
              headerName: 'Status',
              field: 'status' },
            { 
              headerName: 'Application Date',
              field: 'applicationDate' },
            { 
              headerName: 'Applied By UserId',
              field: 'appliedByUserId' },
            { 
              headerName: 'Applied By UserName',
              field: 'appliedByUserName' },
            { 
              headerName: 'UserId UserName',
              field: 'userIdUserName' 
            },
            { 
              headerName: 'Application Title',
              field: 'applicationTitle' 
            },
            { 
              headerName: 'Duration',
              field: 'duration' 
            },
            { 
              headerName: 'Delegated To UserId',
              field: 'delegatedToUserId' 
            },
            { 
              headerName: 'Delegated To UserName',
              field: 'delegatedToUserName' 
            },
            { 
              headerName: 'Approved Date',
              field: 'approvedDate' 
            },
            { 
              headerName: 'Half Day',
              field: 'halfDay' 
            },
          ]
        },
      ],
    },
    getDetailRowData: function(params) {
      params.successCallback(params.data.approvedLeaves);
    },
  } as IDetailCellRendererParams;

  public detailCellRendererParams2: any = {
    detailGridOptions: {
      columnDefs: [
        {
          headerName: 'Remaining Leaves',
          children: [
            { 
              headerName: 'Id', 
              field: 'id'
            },
            { 
              headerName: 'User Id',
              field: 'userId' 
            },
            { 
              headerName: 'Leave Type',
              field: 'leaveType' 
            },
            { 
              headerName: 'Balance',
              field: 'balance' 
            },
          ]
        },
      ],
    },
    getDetailRowData: function(params) {
      params.successCallback(params.data.remainingLeaves);
    },
  } as IDetailCellRendererParams;

  public excelStyles: ExcelStyle[] = [
    {
      id: 'header',
      interior: {
        color: '#aaaaaa',
        patternColor: '',
        pattern: 'Solid',
      },
    },
    {
      id: 'body',
      interior: {
        color: '#dddddd',
        patternColor: '',
        pattern: 'Solid'
      }
    }
  ];

  public defaultExcelExportParams: ExcelExportParams = {
    getCustomContentBelowRow: (params) => getCells(params),
    columnWidth: 140,
  };

  public defaultExcelExportParams2: ExcelExportParams = {
    getCustomContentBelowRow: (params) => getCells2(params),
    columnWidth: 140,
  };

  constructor(private storageService: LocalStorageService,
    private ApprovalService: ApprovalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private HrService: HrService,
    private snackBar: MatSnackBar) {

    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.reportColumnDefs = this.createReportColumnDefs();
    
    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.leaveapplicationForm = this.formBuilder.group({
      id: new FormControl(''),
      userId: new FormControl(''),
      leavetype: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      leaveReason: new FormControl(''),
      status: new FormControl(''),
      applicationDate: new FormControl(''),
      appliedByUserId: new FormControl(''),
      appliedByUserName: new FormControl(''),
      userIdUserName: new FormControl(''),
      applicationTitle: new FormControl(''),
      duration: new FormControl(''),
      delegatedToUserId: new FormControl(''),
      delegatedToUserName: new FormControl(''),
      halfDay: false
    });

    this.leaveReport = this.formBuilder.group({
      startDate: new FormControl(''),
      endDate: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.getAllapprovals();
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    // arbitrarily expand a row for presentational purposes
    params.api.getDisplayedRowAtIndex(0).setExpanded(true);
  }

  getLeaveReport() {
    var leaveApprovalReport = [];
    var filteredReport = [];
    if (!this.leaveReport.get('startDate').value || !this.leaveReport.get('endDate').value) {
      this.snackBar.open('Enter valid dates!', 'Close', { duration: 3000 });
      return;
    } else if (this.leaveReport.get('startDate').value > this.leaveReport.get('endDate').value) {
      this.snackBar.open('Enter valid dates!', 'Close', { duration: 3000 });
      return;
    } else {
      let startDate = formatDate(this.leaveReport.get('startDate').value, 'dd-MM-yyyy', "en-US");
      let endDate = formatDate(this.leaveReport.get('endDate').value, 'dd-MM-yyyy', "en-US");

      this.HrService.getLeaveApprovalReport(startDate, endDate).subscribe((response: any) => {
        this.leaveApprovals = response;
        console.log("leave report: ", response);

        if (this.leaveApprovals) {
          OUTER_LOOP: for (var i in this.leaveApprovals) {
            if (this.leaveApprovals[i].approvedLeaves) {
              leaveApprovalReport.push(this.leaveApprovals[i]);
            } else if (this.leaveApprovals.length !== (Number(i) + 1)) {
              continue OUTER_LOOP;
            } else {
              if (leaveApprovalReport.length == 0) {
                this.snackBar.open('No Entries for these dates!', 'Close', { duration: 3000 });
              }
            }
          }
        }

        // remove redundant entries
        if (leaveApprovalReport.length !== 0) {
          var report = {};
          filteredReport = leaveApprovalReport.filter(obj => !report[obj.userId] && (report[obj.userId] = true));
        }

        if (filteredReport.length !== 0) {
          this.excelApi.setRowData(filteredReport);
          this.excelApi2.setRowData(filteredReport);

          var spreadsheets = [];
          const mainSheet = this.excelApi.getSheetDataForExcel({
            sheetName: 'approved-leaves'
          });
          const sheet = this.excelApi2.getSheetDataForExcel({
            sheetName: 'remaining-leaves'
          });

          if (mainSheet) {
            spreadsheets.push(mainSheet);
          }
          if (sheet) {
            spreadsheets.push(sheet);
          }

          this.excelApi.exportMultipleSheetsAsExcel({
            data: spreadsheets,
            fileName: 'leave-report.xlsx'
          });
        }
      });
      $('#closeModalDeleteLeave').trigger("click");
    }
  }

  createReportColumnDefs() {
    return [
      {
        headerName: 'User Id',
        field: 'userId',
      },
      {
        headerName: 'Name',
        field: 'name',
      },
      {
        headerName: 'Leaves In CurrentRange',
        field: 'leavesTakenInCurrentRange',
      },
    ]
  }

  onExcelGridReady(params): void {
    this.excelApi = params.api;
  }

  onExcelGridReady2(params): void {
    this.excelApi2 = params.api;
  }

  getAllapprovals() {
    let filterType = 'leaveapproval';
    this.ApprovalService.getApprovals(filterType).subscribe((response: any) => {
        this.rowData = response.leaves;
        console.log("getUserLeaveApplicationApproval Response", this.rowData);
      });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: 'Application Title',
        field: 'applicationTitle',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Emp Id',
        field: 'localId','width': 50,
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Applied For',
        field: 'userIdUserName',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Leave Type',
        field: 'leavetype',
        // valueGetter: function(params){
        //   if(params.data.leavetype === 'Earned Leave') {
        //     let leavetype = 'Casual Leave'
        //     return leavetype;
        // } else {
        //     return params.data.leavetype;
        // }
        // },
        filter: true,
        editable: false,
        sortable: true,
        // headerCheckboxSelection: this.isFirstColumn,
        // checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Leave Reason',
        field: 'leaveReason',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Status',
        field: 'status',
        //autoSizeColumns: true,
        maxWidth: 150,
        cellStyle: (params) => {
          if (params.value === 'Save' || params.value === 'save') {
            return { color: 'blue', 'font-weight': 'bold' };
          } else if (params.value === 'Submit' || params.value === 'submit') {
            return { color: 'orange', 'font-weight': 'bold' };
          } else if (params.value === 'Approved' || params.value === 'approved') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Reject' || params.value === 'reject') {
            return { color: 'red', 'font-weight': 'bold' };
          } else if (
            params.value === 'Withdraw' ||
            params.value === 'withdraw'
          ) {
            return { color: 'grey', 'font-weight': 'bold' };
          }
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Application Date',
        field: 'applicationDate',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Half Day',
        field: 'halfDay',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
    ]
  }

  onSelectionChanged(event) {

    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }
  onRowSelect(event) {
    const selectedRows = this.api.getSelectedRows();

    this.selectedRowApprovalSend = selectedRows;
    console.log("Approval selected data", selectedRows);
  }
  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }
  openLeaveApp() {
    // location.href = "{this.tenantId}/dashboard/hr/leaves/leave-application";
    this.router.navigate([this.tenantId + '/dashboard/approval/leave-approval']);
  }


  updateLeaveApp() {
    this.router.navigate([this.tenantId + '/dashboard/approval/leave-approval', { "data": JSON.stringify(this.selectedRowApprovalSend[0].id) }]);
  }


  editOpenModal() {
    this.modeAction = 2;
    this.leaveapplicationForm.patchValue(this.selectedCheckboxData[0])
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].firstName} ${this.selectedCheckboxData[i].lastName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].firstName} ${this.selectedCheckboxData[i].lastName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].firstName} ${this.selectedCheckboxData[i].lastName}`;
    }
  }


  // to open edit modal
  openEdit(item) {
    this.selectedRow = item;
    this.leaveapplicationForm.patchValue(item);

  }

  // getter for easy access to form fields
  get f() {
    return this.leaveapplicationForm.controls;
  }

  bulkUpdateStatus(status){
    let leaveId = [];
    for (let item of this.selectedCheckboxData) {
      leaveId.push(item.id);
    }
    let data = {
      status: status,
      ids: leaveId
    }
    window.alert("This is a backgroud activity and it will take few seconds, please refresh after sometime.");
    this.ApprovalService.bulkStatusUpdateForLeaveApplications(data).subscribe((response: any) => {
      console.log('Status Updated!!!');
    });

  }

}

var getCells = (params: ProcessRowGroupForExportParams) => {
  const cells: ExcelCell[][] = [
    [
      cell(''),
      cell(''),
      cell(''),
      cell('Approved Leaves', 'header'),
      cell('Id', 'header'),
      cell('User Id', 'header'),
      cell('Leave Type', 'header'),
      cell('Start Date', 'header'),
      cell('End Date', 'header'),
      cell('Leave Reason', 'header'),
      cell('Status', 'header'),
      cell('Application Date', 'header'),
      cell('UserId UserName', 'header'),
      cell('Application Title', 'header'),
      cell('Duration', 'header'),
      cell('Delegated To UserId', 'header'),
      cell('Delegated To UserName', 'header'),
      cell('Approved Date', 'header'),
      cell('Half Day', 'header'),
    ],
  ].concat(
    params.node.data.approvedLeaves.map(function (record: any) {
      return [
        cell(''),
        cell(''),
        cell(''),
        cell(''),
        cell(record.id, 'body'),
        cell(record.userId, 'body'),
        cell(record.leavetype, 'body'),
        cell(record.startDate, 'body'),
        cell(record.endDate, 'body'),
        cell(record.leaveReason, 'body'),
        cell(record.status, 'body'),
        cell(record.applicationDate, 'body'),
        cell(record.userIdUserName, 'body'),
        cell(record.applicationTitle, 'body'),
        cell(record.duration, 'body'),
        cell(record.delegatedToUserId, 'body'),
        cell(record.delegatedToUserName, 'body'),
        cell(record.approvedDate, 'body'),
        cell(record.halfDay, 'body'),
      ];
    }),
    [[]]
  );
  return cells;
};

var getCells2 = (params: ProcessRowGroupForExportParams) => {
  const cells: ExcelCell[][] = [
    [
      cell(''),
      cell(''),
      cell(''),
      cell('Remaining Leaves', 'header'),
      cell('Id', 'header'),
      cell('User Id', 'header'),
      cell('Leave Type', 'header'),
      cell('Balance', 'header'),
    ],
  ].concat(
    params.node.data.remainingLeaves.map(function (record: any) {
      return [
        cell(''),
        cell(''),
        cell(''),
        cell(''),
        cell(record.id, 'body'),
        cell(record.userId, 'body'),
        cell(record.leaveType, 'body'),
        cell(record.balance, 'body'),
      ];
    }),
    [[]]
  );
  return cells;
};

function cell(text: string, styleId?: string): ExcelCell {
  return {
    styleId: styleId,
    data: {
      type: /^\d+$/.test(text) ? 'Number' : 'String',
      value: String(text),
    },
  };
}
